import React from "react";
import {
  // FaTwitter,
  FaGithub,
  FaLinkedinIn,
} from "react-icons/fa";

const SocialShare = [
  // { Social: <FaTwitter />, link: "https://www.twitter.com/" },
  { Social: <FaGithub/>, link: "https://www.instagram.com/" },
  { Social: <FaLinkedinIn />, link: "https://www.linkedin.com/" },
];

const Footer = () => {
  return (
    <>
      <div className="row align-items-center" id="footer">
        <div className="col-md-6 my-2">
          <div className="nav justify-content-center justify-content-md-start">
            {SocialShare.map((val, i) => (
              <a key={i} href={`${val.link}`} rel="noreferrer" target="_blank">
                {val.Social}
              </a>
            ))}
          </div>
          {/* End .nav */}
        </div>
        {/* End .col */}

        <div className="col-md-6 my-2 text-center text-md-end">
          <p>
            © {new Date().getFullYear()} Laura Sims
          </p>
        </div>
        {/* End .col */}
      </div>
      {/* End .row */}
    </>
  );
};

export default Footer;
